import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { Tweaks } from "@/utils/types/ui";

const TWEAK_DEFAULTS: Tweaks = {
  density: 1.04,
  layoutVariant: "balanced",
  dark: false,
  compactSidebar: false,
  accentHue: 145,
  tabStyle: "pill",
  tabShowKpi: false,
  tabSemanticNames: false,
};

type TweaksStore = Tweaks & {
  setTweak: <K extends keyof Tweaks>(key: K, value: Tweaks[K]) => void;
  setTweaks: (patch: Partial<Tweaks>) => void;
  reset: () => void;
};

export const useTweaksStore = create<TweaksStore>()(
  persist(
    (set) => ({
      ...TWEAK_DEFAULTS,
      setTweak: (key, value) => set({ [key]: value } as Partial<Tweaks>),
      setTweaks: (patch) => set(patch),
      reset: () => set(TWEAK_DEFAULTS),
    }),
    {
      name: "palate_tweaks",
      storage: createJSONStorage(() => localStorage),
      // Persist only the data fields; methods aren't serializable.
      partialize: (s) => ({
        density: s.density,
        layoutVariant: s.layoutVariant,
        dark: s.dark,
        compactSidebar: s.compactSidebar,
        accentHue: s.accentHue,
        tabStyle: s.tabStyle,
        tabShowKpi: s.tabShowKpi,
        tabSemanticNames: s.tabSemanticNames,
      }),
    }
  )
);
